
import React, { useState } from "react";
import { clientId, redirectUri, authority, scopes } from "../../AuthConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";
const Login = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const msalConfig = {
    auth: {
      clientId,
      redirectUri,
      authority,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };
  const msalInstance = new PublicClientApplication(msalConfig);
  const isLogin = async (token, name) => {
    // const formData = new FormData();
    // formData.append("files", name, name);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WEB_SERVICE_URL}/api/Login/Login?username=${name}`,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (response.status === 200) {
        let userInfo = await response.json();

        console.log("Saf", userInfo?.Profile, userInfo?.Profile?.Employeeid);

        if (userInfo) {
          props.dispatch({
            type: "Token",
            value: token,
          });
          props.dispatch({
            type: "userType",
            value: userInfo?.Profile?.UserType,
          });
          props.dispatch({
            type: "userName",
            value: userInfo?.Profile?.Name,
          });
          props.dispatch({
            type: "UserId",
            value: "543543",
          });
        }
        if (userInfo?.Profile?.EnableGoodsExitDate) {
          sessionStorage.setItem(
            "EnableGoodsExitDate",
            userInfo.Profile.EnableGoodsExitDate
          );
        }

        if (userInfo?.Profile?.Employeeid) {
          toast.success("Login successful.", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
        else {
          console.log("Profile field missing:", userInfo?.Profile);
        }
      }
    } catch (err) {
      console.error("Login Error:", err);
    }
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      const loginResponse = await msalInstance.loginPopup({
        scopes,
      });
      await isLogin(
        loginResponse.accessToken,
        loginResponse.account.username,
        props
      );
    } catch (error) {
      console.error("Login Error:", error);

      toast.error("Microsoft login failed.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  console.log(props, "lsussusu");

  return (
    <LoadingScreen
      loading={isLoading}
      bgColor="#f1f1f1"
      spinnerColor="#9ee5f8"
      textColor="#676767"
      logoSrc={process.env.REACT_APP_ENV + "/assets/images/logo/logo.png"}
    >
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div
          className="card shadow-lg rounded-4 text-center p-4"
          style={{ maxWidth: "400px" }}
        >
          <img
            src={process.env.REACT_APP_ENV + "/assets/images/logo/logo.png"}
            alt="eGGP Logo"
            className="img-fluid mb-3"
          />
          <h3 className="mb-2 fw-bold text-primary">Welcome to eGGP</h3>
          <p className="text-muted mb-4">
            Your gateway to seamless management and productivity.
          </p>
          <button className="btn btn-primary w-100 py-2" onClick={handleLogin}>
            Login
          </button>
        </div>
      </div>
    </LoadingScreen>
  );
};

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(Login);
